import { make } from 'vuex-pathify'
import importer from './course/importer'

const state = {
}

const getters = {
}

const mutations = {
    ...make.mutations(state),
}

export default {
    namespaced: true,
    modules: {
        importer
    },
    state,
    getters,
    mutations,
}